import {FormControl, FormControlLabel, Radio, RadioGroup, FormHelperText} from "@mui/material"

const RadioGroupField = ({
  input: { onChange, value },
  radioElements,
  onUpdate = null,
  meta,
  label,
  ...rest
}) =>
  <>
    <FormControl style={{width: "100%"}}>
      {label}
      <RadioGroup
        name="anything"
        value={value}
        onChange={(event) => {
          const selected = radioElements.find(
            (element) => String(element.val) === event.target.value
          );
          const newValue = selected ? selected.val : event.target.value;
          onChange(newValue);
          if (typeof onUpdate === "function") {
            onUpdate(newValue);
          }
        }}
        style={{width: "100%"}}
        {...rest}
      >
        {
          radioElements.map(({label, val, style}, idx) =>
            <FormControlLabel key={idx} value={val} style={style} control={<Radio />} label={label}/>
          )
        }
      </RadioGroup>
    </FormControl>
    {meta.error && meta.touched && (
      <FormHelperText error={true} id="radio-group-error-text">
        {meta.error}
      </FormHelperText>
    )}
  </>

export default RadioGroupField;
